import { useEffect } from "react";
import {
    CheckCircle,
    AlertCircle,
    Info,
    X
} from "lucide-react";

import "./Toast.scss";

export default function Toast({
    message,
    type = "success",
    onClose,
    duration = 4000
}) {
    useEffect(() => {
        if (!message) return;

        const timer = setTimeout(() => {
            onClose?.();
        }, duration);

        return () => clearTimeout(timer);
    }, [message, duration, onClose]);

    if (!message) return null;

    const icons = {
        success: CheckCircle,
        error: AlertCircle,
        warning: AlertCircle,
        info: Info
    };

    const Icon = icons[type] || CheckCircle;

    return (
        <div className={`toast toast--${type}`}>
            <div className="toast__icon">
                <Icon size={20} />
            </div>

            <div className="toast__content">
                <strong>
                    {type === "success" && "Sucesso"}
                    {type === "error" && "Não foi possível concluir"}
                    {type === "warning" && "Atenção"}
                    {type === "info" && "Informação"}
                </strong>

                <span>{message}</span>
            </div>

            <button
                className="toast__close"
                onClick={onClose}
                aria-label="Fechar"
            >
                <X size={17} />
            </button>
        </div>
    );
}

